// extracted by mini-css-extract-plugin
export var experienceBox = "experience-module--experienceBox--URHJt";
export var relatedSkills = "experience-module--relatedSkills--eCRdM";
export var slidein = "experience-module--slidein--UieaJ";
export var visibleBox = "experience-module--visibleBox--5yLfe";